export default __webpack_public_path__ + "static/media/i126hp.42874ab8.webp";